import { render, staticRenderFns } from "./ZhangHaoZhuXiao.vue?vue&type=template&id=28ffb88e&scoped=true&"
import script from "./ZhangHaoZhuXiao.vue?vue&type=script&lang=js&"
export * from "./ZhangHaoZhuXiao.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/zx-agreement.css?vue&type=style&index=0&id=28ffb88e&prod&scoped=true&lang=css&"
import style1 from "./ZhangHaoZhuXiao.vue?vue&type=style&index=1&id=28ffb88e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ffb88e",
  null
  
)

export default component.exports